import React, { Component } from 'react'
import { Dropdown,  Menu } from 'semantic-ui-react'

export default class MenuExampleHeaderVertical extends Component {
  state = {}
  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state

    return (
      <Menu vertical>
        <Menu.Item
          name="dashboard"
          active={activeItem === "dashboard"}
          onClick={this.handleItemClick}
        >
          Dashboard
        </Menu.Item>

        <Menu.Item>
          <Menu.Header>Cession de Capture</Menu.Header>

          <Menu.Menu>
            <Menu.Item
              name='Cédant'
              active={activeItem === 'rails'}
              onClick={this.handleItemClick}
            />
            <Menu.Item
              name='Acquéreur'
              active={activeItem === 'python'}
              onClick={this.handleItemClick}
            />
          </Menu.Menu>
        </Menu.Item>

        <Menu.Item>
          <Menu.Header>Cession de Produit</Menu.Header>

          <Menu.Menu>
            <Menu.Item
              name='Cédant'
              active={activeItem === 'shared'}
              onClick={this.handleItemClick}
            />
            <Menu.Item
              name='Acquéreur'
              active={activeItem === 'dedicated'}
              onClick={this.handleItemClick}
            />
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item
          name="Cession d'export"
          active={activeItem === "Cession d'export"}
          onClick={this.handleItemClick}
          icon position="right"
        >
          
          Cession d'export
      
        </Menu.Item>
        <Menu.Item as={Dropdown}  active={true} text='More'>
          <Dropdown.Menu>
            <Dropdown.Item active={true} icon='edit' text='Edit Profile' />
            <Dropdown.Item icon='globe' text='Choose Language' />
            <Dropdown.Item icon='settings' text='Account Settings' />
          </Dropdown.Menu>
        </Menu.Item>
   
      </Menu>
    )
  }
}
